<ng-container *ngIf="data.fields.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.fields.Title"></span>
    <button
      *ngIf="data.fields.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>

<div>
  <div class="row border-bottom-primary">
    <div class="search-field offset-md-6 col-md-6 p-0 pb-1 relative">
      <i class="icon-search"></i>
      <input
        class="form-control pr-3 pl-4"
        #searchInput
        [(ngModel)]="search"
        name="search"
        maxlength="80"
        [placeholder]="items.search.fields.label.value"
      />
      <div
        class="search-clear-icon"
        (click)="clearValue()"
        [hidden]="!search || search.length === 0"
      >
        <i class="icon-clear-input-value"></i>
      </div>
    </div>
  </div>
  <div class="table-responsive" [hidden]="isEmpty">
    <table class="table transfer-table mt-2">
      <colgroup>
        <col class="w-10" />
        <col class="w-8" />
      </colgroup>
      <thead>
        <tr>
          <th *scText="items.country.fields.label"></th>
          <th
            class="text-right"
            *scText="items.abbreviations.fields.label"
          ></th>
        </tr>
      </thead>
    </table>
    <virtual-scroller
      #scroll
      [items]="filteredArray | async"
      [enableUnequalChildrenSizes]="true"
    >
      <table class="table transfer-table with-hover">
        <colgroup>
          <col class="w-10" />
          <col class="w-8" />
        </colgroup>
        <tbody #container>
          <ng-container *ngFor="let country of scroll.viewPortItems">
            <tr (click)="confirm(country)">
              <td class="d-flex align-items-center">
                <div class="country-list-flag">
                  <span
                    class="flag-icon flag-icon-{{
                      country.countryCode
                    }} flag-icon-squared"
                  ></span>
                </div>
                <span class="ml-1">{{ country.countryName }}</span>
              </td>
              <td class="text-right">
                <span class="country-code">{{ country.countryCode }}</span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </virtual-scroller> 
  </div>
  <div *ngIf="isEmpty" class="empty-page">
    <div><i class="icon-empty-page large"></i></div>
    <div class="fs-20" *scText="items.emptyMessage.fields.label"></div>
  </div>
</div>
